import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
import { Calendar } from 'theme/icons';
export var DateRangeInputContainer = styled.div.withConfig({
  displayName: "DateRangeFilterstyle__DateRangeInputContainer",
  componentId: "sc-16h9i7-0"
})(["display:inline-block;width:165px;"]);
export var StyledCalendar = styled(Calendar).withConfig({
  displayName: "DateRangeFilterstyle__StyledCalendar",
  componentId: "sc-16h9i7-1"
})(["& path{fill:", ";}"], colorUsage.defaultIconColor);